import { useState, useEffect } from 'react';
import authService from '../services/authService';

/**
 * Lightweight auth hook for menu pages
 * Only provides minimal auth state needed for menu functionality
 */
export const useMenuAuth = () => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const initAuth = () => {
      try {
        const currentUser = authService.getCurrentUser();
        if (currentUser?.user?.role === 'admin') {
          setIsAdmin(true);
        }
      } catch (error) {
        // Silently handle auth errors for menu pages
        console.warn('Auth check failed for menu page:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, []);

  return {
    isAdmin,
    isLoading
  };
}; 